module.exports = __webpack_public_path__ + "img/New-Partner.5151cf79.svg";